import { useEffect } from "react";
import Header from "../sections/Header";
import Hero from "../sections/Hero";
import Services from "../sections/Services";
import About from "../sections/About";
import FounderStory from "../sections/FounderStory";
import WhyUs from "../sections/WhyUs";
import Process from "../sections/Process";
import Recruitment from "../sections/Recruitment";
import Community from "../sections/Community";
import ReferralPartners from "../sections/ReferralPartners";
import FAQ from "../sections/FAQ";
import Contact from "../sections/Contact";
import Footer from "../sections/Footer";
import StickyCTA from "../sections/StickyCTA";
import { BRAND, KEYWORDS } from "../lib/constants";

export default function Home() {
  useEffect(() => {
    // SEO meta tags
    const setMeta = (name, content, property = false) => {
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    document.title =
      "Madison Peaceful Path Home Care | Compassionate In-Home Senior Care in Madison, WI";

    setMeta(
      "description",
      "Trusted in-home senior care in Madison, Wisconsin. Compassionate, dignity-focused non-medical home care, companionship, dementia support, and respite care. Call 608-513-7639."
    );
    setMeta("keywords", KEYWORDS.join(", "));
    setMeta("og:title", "Madison Peaceful Path Home Care | Madison, WI", true);
    setMeta(
      "og:description",
      "Compassionate in-home care rooted in dignity, consistency, and peace of mind. Serving Madison families.",
      true
    );
    setMeta("og:type", "website", true);

    // Local business schema
    const schema = {
      "@context": "https://schema.org",
      "@type": "HomeAndConstructionBusiness",
      additionalType: "https://schema.org/MedicalBusiness",
      name: BRAND.llc,
      url: `https://${BRAND.domain}`,
      telephone: BRAND.phone,
      email: BRAND.email,
      areaServed: {
        "@type": "City",
        name: "Madison",
        containedInPlace: { "@type": "State", name: "Wisconsin" },
      },
      address: {
        "@type": "PostalAddress",
        addressLocality: "Madison",
        addressRegion: "WI",
        addressCountry: "US",
      },
      description:
        "Non-medical in-home senior care, companionship, dementia support, personal care assistance, respite care, and post-hospital support in Madison, Wisconsin.",
    };
    let script = document.getElementById("local-business-schema");
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "local-business-schema";
      document.head.appendChild(script);
    }
    script.text = JSON.stringify(schema);
  }, []);

  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <Services />
      <WhyUs />
      <FounderStory />
      <About />
      <Process />
      <Recruitment />
      <Community />
      <ReferralPartners />
      <FAQ />
      <Contact />
      <Footer />
      <StickyCTA />
    </main>
  );
}
